import { render, staticRenderFns } from "./RejectTitle.vue?vue&type=template&id=2c633d08"
import script from "./RejectTitle.vue?vue&type=script&lang=js"
export * from "./RejectTitle.vue?vue&type=script&lang=js"
import style0 from "./RejectTitle.vue?vue&type=style&index=0&id=2c633d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports